import { stringCompare, characterCompare } from '@synconset/sorting';
import EpisodicCharacter from './episodic-character.entity';
import EpisodicActor from '../episodic-actors/episodic-actor.entity';

export function sort(
	chars: EpisodicCharacter[],
	desc: boolean = false
): EpisodicCharacter[] {
	const sorted = chars.sort(characterCompare);
	if (desc) {
		return [...sorted.reverse()];
	}
	return [...sorted];
}

export function sortBackground(chars: EpisodicCharacter[], desc?: boolean) {
	return sort(chars, desc);
}

export function sortByActorName(
	chars: EpisodicCharacter[],
	actorMap: { [id: number]: EpisodicActor },
	desc?: boolean
) {
	const sorted = chars.sort((a, b) => {
		const aName = actorMap[a.episodic_actor_id]
			? actorMap[a.episodic_actor_id].last_name
			: null;
		const bName = actorMap[b.episodic_actor_id]
			? actorMap[b.episodic_actor_id].last_name
			: null;
		return stringCompare(aName, bName);
	});
	if (desc) {
		return [...sorted.reverse()];
	}
	return [...sorted];
}

export function sortPrimary(
	chars: EpisodicCharacter[],
	actorMap: { [id: number]: EpisodicActor },
	sortBy: string,
	desc: boolean
) {
	if (sortBy === 'first_name') {
		return sort(chars, desc);
	} else if (sortBy === 'episodic_actor_id') {
		return [...sortByActorName(chars, actorMap, desc)];
	} else {
		return sort(chars, desc);
	}
}

export function sortRank(a, b) {
	const rank = b.getCharNumRank() - a.getCharNumRank();
	if (rank === 0) {
		const charNumCompare = a
			.getCharNumOrEmptyString()
			.localeCompare(b.getCharNumOrEmptyString() as string, [], {
				numeric: true,
				ignorePunctuation: false,
			});
		return charNumCompare !== 0
			? charNumCompare
			: a.getName().localeCompare(b.getName());
	}
	return rank;
}

export function sortByRankAndCharNum(
	chars: EpisodicCharacter[],
	desc: boolean = false
) {
	const sorted = chars.sort(sortRank);
	if (desc) {
		return [...sorted.reverse()];
	}
	return [...sorted];
}
